<div class="contenedor" [ngClass]="{ difuminar_Fondo: loadingMinute }">
  <article id="htmlData" #pdfElement>
    <article class="container_father">
      <section id="MinuteHeader" class="subcontainer">
        <mat-card class="withoutBorder">
          <mat-card-content>
            <section class="grid_container">
              <section class="subcontainer">
                <div class="row" style="padding: 0px 16px">
                  <div class="col-md-3">
                    <div class="row text-right">
                      <div class="alignCenter">
                        <qrcode
                          [qrdata]="myAngularxQrCode"
                          [width]="150"
                          [imageSrc]="
                            '../../../../../../../assets/images/logos/logo-inge-fondo.jpg'
                          "
                          [imageHeight]="32"
                          [imageWidth]="32"
                          [errorCorrectionLevel]="'M'"
                        >
                        </qrcode>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row text-right">
                      <h2 class="alignCenter">
                        {{
                          minuteRequestClient?.name
                            ? minuteRequestClient.name
                            : "Cargando..."
                        }}
                      </h2>
                    </div>
                    <div class="row text-right">
                      <h4 class="alignCenter">
                        {{
                          minuteRequestClient?.fullRut
                            ? minuteRequestClient.fullRut
                            : "-"
                        }}
                      </h4>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <p><b>Estado: &nbsp;</b></p>
                      <div class="text-right">
                        <div [ngSwitch]="resolutionName">
                          <div *ngSwitchCase="'Pendiente'">
                            <p style="color: orange">
                              {{ minuteRequestRealTime?.finalResolutionName }}
                            </p>
                          </div>
                          <div *ngSwitchCase="'Aprobado'">
                            <p style="color: green">
                              {{ minuteRequestRealTime?.finalResolutionName }}
                            </p>
                          </div>
                          <div *ngSwitchCase="'Rechazado'">
                            <p style="color: red">
                              {{ minuteRequestRealTime?.finalResolutionName }}
                            </p>
                          </div>
                          <div *ngSwitchCase="'Eliminada'">
                            <p style="color: red">
                              {{ minuteRequestRealTime?.finalResolutionName }}
                            </p>
                          </div>
                          <div *ngSwitchCase="'Cancelada'">
                            <p style="color: red">
                              {{ minuteRequestRealTime?.finalResolutionName }}
                            </p>
                          </div>
                          <div *ngSwitchCase="'En Borrador'">
                            <p style="color: gray">
                              {{ minuteRequestRealTime?.finalResolutionName }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <p class="text-right">
                        <b>Creación: </b
                        >{{
                          minuteRequestRealTime?.createdAt
                            ? (minuteRequestRealTime?.createdAt
                              | date : "dd/MM/yyyy " : "-06:00")
                            : ""
                        }}
                        -
                        {{
                          minuteRequestRealTime?.createdAt
                            ? (minuteRequestRealTime?.createdAt
                                | date : "shortTime" : "-06:00") + "Hrs"
                            : ""
                        }}
                      </p>
                    </div>
                    <div class="row">
                      <p class="text-right">
                        <b>Expiración: </b
                        >{{
                          minuteRequestRealTime?.dueDate | date : "dd/MM/yyyy"
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </section>
            </section>
          </mat-card-content></mat-card
        >
      </section>
    </article>
    <article class="container_father">
      <section id="ClienteFactoring" class="subcontainer">
        <mat-card>
          <mat-card-header>
            <mat-card-title>
              <h4>Identificación</h4>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <section class="grid_container">
              <section class="subcontainer">
                <div class="row">
                  <div class="col-md">
                    <p>
                      <b>Email: </b
                      >{{
                        minuteRequestClient?.email
                          ? minuteRequestClient.email
                          : "-"
                      }}
                    </p>
                    <p>
                      <b>Teléfono: </b>
                      {{
                        minuteRequestClient?.phone
                          ? minuteRequestClient.phone
                          : "-"
                      }}
                    </p>
                    <p>
                      <b>Sitio web: </b
                      >{{
                        minuteRequestClient?.website
                          ? minuteRequestClient.website
                          : "-"
                      }}
                    </p>
                  </div>
                  <div class="col-md">
                    <p>
                      <b>Dirección: </b
                      >{{
                        minuteRequestClient?.address
                          ? minuteRequestClient.address
                          : "-"
                      }}
                    </p>
                    <p>
                      <b>Fogape: </b>
                      {{ minuteRequestClient?.fogape ? "Sí" : "No" }}
                    </p>
                    <p>
                      <b>Deuda Fogape: </b>
                      {{
                        minuteRequestClient?.deudaFogape
                          ? minuteRequestClient.deudaFogape + "UF"
                          : "0UF"
                      }}
                    </p>
                  </div>
                </div>
              </section>
            </section>
          </mat-card-content>
        </mat-card>
      </section>
    </article>
    <section style="display: none">
      <mat-card class="container_minutes info">
        <mat-card-content>
          <article class="subcontainer_minutes_grid">
            <section class="section_info_general">
              <h4>Nombre:</h4>
              <h4>RUT:</h4>
              <h4>Email:</h4>
              <h4>Teléfono:</h4>
              <h4>Web:</h4>
            </section>
            <section class="section_info">
              <h4></h4>
              <h4></h4>
              <h4>
                {{
                  minuteRequestClient?.email
                    ? minuteRequestClient.email
                    : "No Informado"
                }}
              </h4>
              <h4>
                {{
                  minuteRequestClient?.phone
                    ? minuteRequestClient.phone
                    : "No Informado"
                }}
              </h4>
              <h4>
                {{
                  minuteRequestClient?.website
                    ? minuteRequestClient.website
                    : "No Informado"
                }}
              </h4>
            </section>
          </article>
        </mat-card-content>
        <mat-card-content>
          <article class="subcontainer_minutes_grid">
            <section class="section_info_general">
              <h4>Actividad Economica:</h4>
              <h4>Direccion Particular:</h4>
              <h4>Fecha de Creacion de minuta:</h4>
              <h4>Fecha de Expiracion:</h4>
            </section>
            <section class="section_info">
              <h4>
                {{
                  minuteRequestClient?.currentEconomicActivity
                    ? minuteRequestClient.currentEconomicActivity
                    : "No Informado"
                }}
              </h4>
              <h4>
                {{
                  minuteRequestClient?.address
                    ? minuteRequestClient.address
                    : "No Informado"
                }}
              </h4>
            </section>
          </article>
        </mat-card-content>
      </mat-card>
    </section>
    <div style="width: 100%; padding-left: 20px">
      <h3>
        Descripción de la Minuta
        <fa-icon
          *ngIf="!minuteRequestRealTime?.isClosed"
          (click)="mostrarActualizarDescripcion()"
          [icon]="icons.faPen"
          style="cursor: pointer; font-size: 16px; margin-left: 1rem"
        >
        </fa-icon>
        <fa-icon
          *ngIf="!minuteRequestRealTime?.isClosed"
          (click)="mostrarActualizarDescripcion()"
          [icon]="icons.faBullhorn"
          style="cursor: pointer; font-size: 16px; margin-left: 1rem"
        >
        </fa-icon>
      </h3>
    </div>
    <mat-card>
      <mat-card-content>
        <section class="MinuteDescription">
          <span>
            {{
              minuteRequestRealTime?.description
                ? minuteRequestRealTime.description
                : "No se ha incluido una descripción"
            }}
          </span>
        </section>
      </mat-card-content>
    </mat-card>

    <article *ngIf="isCompany == true" style="width: 100%; margin-left: 20px">
      <section class="div_socios">
        <div>
          <h3>Socios</h3>
        </div>
        <div
          *ngIf="!minuteRequestRealTime?.isClosed && hasDicomPermission"
          class="btn_socios"
        >
          <button
            mat-raised-button
            color="primary"
            (click)="getDicomPartners()"
          >
            Consultar DICOM Socios
          </button>
        </div>
      </section>
    </article>
    <mat-card *ngIf="isCompany == true">
      <mat-card-content>
        <section class="Owners">
          <app-minutes-owners
            [minuteRequestRealTime]="minuteRequestRealTime"
            [minuteOwnersRequest]="minuteOwnersRequest"
            [forMinute]="true"
          ></app-minutes-owners>
        </section>
      </mat-card-content>
    </mat-card>

    <!-- <section class="container_client">
      <div style="width: 100%; margin-left: 20px">
        <h3>Descripción del cliente</h3>
      </div>
      <mat-card class="subcontainer_client">
        <mat-card-content>
          <article class="subcontainer_minutes_grid">
            <section class="section_info_general">
              <h4>SII:</h4>
              <h4>N° de Factura:</h4>
              <h4>TGR al dia:</h4>
              <h4>Fecha inicio Actividades:</h4>
            </section>
            <section class="section_info">
              <h4>
                {{ minuteRequestClient?.siiConnected ? "Sí" : "No" }}
              </h4>
              <h4>
                {{ minuteRequestClient?.sellInvoices }}
              </h4>
              <h4>
                <div class="modalTgrInfo" (click)="mostrarInforTgr()" style="cursor: pointer">
                  {{ minuteRequestClient?.hasTgr ? "No" : "Si" }}
                </div>
              </h4>
              <h4>
                {{
                minuteRequestClient?.startCurrentActivity
                ? (minuteRequestClient.startCurrentActivity
                | date : "dd/MM/yyyy")
                : "-"
                }}
              </h4>
            </section>
          </article>
        </mat-card-content>
  
        <mat-card-content>
          <article class="subcontainer_minutes_grid">
            <section class="section_info_general">
              <h4>CMF MM$:</h4>
              <h4>Dicom MM$:</h4>
              <h4>Fogape:</h4>
              <h4>Cliente SAGR:</h4>
              <h4>Cliente Factoring:</h4>
            </section>
            <section class="section_info">
              <h4 (click)="mostrarInforCmf()" style="cursor: pointer">
                {{ minuteRequestClient?.hasCmf ? "Sí" : "No" }}
              </h4>
              <h4>
                <a target="_blank" href="{{ pathUrlDicom }}">
                  ${{ minuteRequestClient?.dicomAmount | number }}
                </a>
              </h4>
              <h4>
                {{ minuteRequestClient?.fogape ? "Sí" : "No" }}
              </h4>
              <h4 (click)="mostrarInfoIngeSAGR()" style="cursor: pointer">
                {{ minuteRequestClient?.ingeClient ? "Sí" : "No" }}
              </h4>
              <h4>
                {{ minuteRequestClient?.factoringClient ? "Sí" : "No" }}
              </h4>
            </section>
          </article>
        </mat-card-content>
  
        <mat-card-content>
          <article class="subcontainer_minutes_grid">
            <section class="section_info_general">
              <h4>N° Factura Formula:</h4>
              <h4>Monto Total FF:</h4>
              <h4>Riesgo a Alcanzar:</h4>
              <h4>N° Operaciones SAGR:</h4>
            </section>
            <section class="section_info">
              <h4>
                {{ minuteRequestClient?.invoicesTransferFormula | number }}
              </h4>
              <h4>
                {{ minuteRequestClient?.totalPaidFacturasFormula | currency:'CLP':'symbol' }}
              </h4>
              <h4>
                {{ originalFactoringOperation?.financedAmount ? (originalFactoringOperation?.financedAmount |
                currency:'CLP':'symbol') : "-" }}
              </h4>
              <h4>
                {{ minuteRequestClient?.warrantyOperations | number }}
              </h4>
            </section>
          </article>
        </mat-card-content>
      </mat-card>
    </section>
    <section class="container_line">
      <div style="width: 100%; margin-left: 20px">
        <h3>Lineas</h3>
      </div>
      <mat-card class="container_minutes">
        <mat-card-content>
          <article class="subcontainer_minutes_grid">
            <section class="section_info_general">
              <h4>Línea Garantía:</h4>
              <h4>Disponible:</h4>
              <h4>Usado:</h4>
            </section>
            <section class="section_info">
              <div class="flex">
                {{ minuteRequestRealTime?.currency }}:
                {{
                minuteRequestRealTime?.warrantyLine
                | currency : "CLP" : "symbol"
                }}
                <div>
  
                  <fa-icon *ngIf="!minuteRequestRealTime?.isClosed" (click)="openMinuteRequestLine(1)"
                    [icon]="icons.faPen" style="cursor: pointer; font-size: 16px; margin-left: 1rem">
                  </fa-icon>
  
                </div>
              </div>
              <h4>
                CLP: ${{ minuteSnapshot?.availableWarrantyLine | number }}
              </h4>
              <h4>CLP: ${{ minuteSnapshot?.usedWarrantyLine | number }}</h4>
            </section>
          </article>
        </mat-card-content>
        <mat-card-content>
          <article class="subcontainer_minutes_grid">
            <section class="section_info_general">
              <h4>Línea Factoring:</h4>
              <h4>Disponible:</h4>
              <h4>Usado:</h4>
            </section>
            <section class="section_info">
              <div class="flex">
                {{ minuteRequestRealTime?.currency }}:
                {{
                minuteRequestRealTime?.factoringLine
                | currency : "CLP" : "symbol"
                }}
                <div>
                  <fa-icon *ngIf="!minuteRequestRealTime?.isClosed" (click)="openMinuteRequestLine(0)"
                    [icon]="icons.faPen" style="cursor: pointer; font-size: 16px; margin-left: 1rem"></fa-icon>
                </div>
              </div>
              <h4>CLP: ${{ minuteSnapshot?.availableLine | number }}</h4>
              <h4>CLP: ${{ minuteSnapshot?.usedLine | number }}</h4>
            </section>
          </article>
        </mat-card-content>
      </mat-card>
    </section> -->
  </article>

  <article class="container_father">
    <section id="ClienteFactoring" class="subcontainer">
      <div style="width: 100%; padding-left: 20px">
        <h3>Cliente Factoring</h3>
      </div>
      <mat-card>
        <mat-card-content>
          <section class="grid_container">
            <section class="subcontainer">
              <div class="row">
                <div class="col">
                  <p>
                    <b>Facturas cedidas: </b
                    >{{
                      minuteRequestClient?.invoicesTransferFormula
                        ? minuteRequestClient?.invoicesTransferFormula
                        : ("0" | number)
                    }}
                  </p>
                  <p>
                    <b>Monto total cedido:</b>
                    {{
                      minuteRequestClient?.tgr?.amount
                        ? (minuteRequestClient?.tgr?.amount
                          | currency : "CLP" : "symbol")
                        : "$0"
                    }}
                  </p>
                  <p>
                    <b>Nueva línea solicitada: </b>
                    {{
                      minuteRequestRealTime?.factoringLine
                        | currency : "CLP" : "symbol"
                    }}
                    <fa-icon
                      *ngIf="!minuteRequestRealTime?.isClosed"
                      (click)="openMinuteRequestLine(0)"
                      [icon]="icons.faPen"
                      style="
                        cursor: pointer;
                        font-size: 16px;
                        margin-left: 1rem;
                      "
                    ></fa-icon>
                  </p>
                </div>
              </div>
            </section>
          </section>
        </mat-card-content>
        <ng-template #noClienteFactoring>
          <mat-card-content>
            <p><b>No es cliente Factoring</b></p>
          </mat-card-content>
        </ng-template>
      </mat-card>
    </section>
  </article>
  <article class="container_father">
    <section id="ClienteSAGR" class="subcontainer">
      <div style="width: 100%; padding-left: 20px">
        <h3>Cliente SAGR</h3>
      </div>
      <mat-card>
        <mat-card-content
          *ngIf="minuteRequestClient?.ingeClient; else noClienteSAGR"
        >
          <section class="grid_container">
            <section class="subcontainer">
              <div class="row">
                <div class="col">
                  <!-- <p><b>Fecha de inicio: </b>{{this.minuteRequestClient.legacyData.startDate | date : "dd-MM-yyyy" }}</p> -->
                  <!-- <p><b>Fecha de inicio desde ahora: </b>{{this.minuteRequestClient.legacyData.startDateFromNow | number}} dias</p> -->
                  <p>
                    <b>Fecha de creación: </b
                    >{{
                      this.minuteRequestClient.legacyData.inserted
                        | date : "dd-MM-yyyy"
                    }}
                  </p>
                  <p>
                    <b>Ejecutivo: </b
                    >{{ this.minuteRequestClient.legacyData.executive }}
                  </p>
                  <p>
                    <b>Último scoring: </b
                    >{{
                      this.minuteRequestClient.legacyData
                        .lastScoringStateDescription
                    }}
                  </p>
                  <p>
                    <b>Riesgo total asumido: </b
                    >{{
                      this.minuteRequestClient.legacyData.totalRiskTaken
                        | currency : "CLP" : "symbol"
                    }}
                  </p>
                  <p>
                    <b>Cantidad total de garantías: </b
                    >{{
                      this.minuteRequestClient.legacyData.totalWarrantiesCount
                        | number
                    }}
                  </p>
                </div>
                <div class="col">
                  <p>
                    <b>Línea: </b
                    >{{
                      this.minuteRequestClient.legacyData.linea
                        | currency : "CLP" : "symbol"
                    }}
                  </p>
                  <p>
                    <b>Línea disponible: </b
                    >{{
                      this.minuteRequestClient.legacyData.availableLine
                        | currency : "CLP" : "symbol"
                    }}
                  </p>
                  <p>
                    <b>Línea total utilizada: </b
                    >{{
                      this.minuteRequestClient.legacyData.totalUsedLine
                        | currency : "CLP" : "symbol"
                    }}
                  </p>
                  <p>
                    <b>Garantías vigentes: </b
                    >{{
                      this.minuteRequestClient.legacyData
                        .availableWarrantiesCount | number
                    }}
                  </p>
                  <p>
                    <b>Nueva línea solicitada: </b>

                    {{
                      minuteRequestRealTime?.warrantyLine
                        | currency : "CLP" : "symbol"
                    }}
                    <fa-icon
                      *ngIf="!minuteRequestRealTime?.isClosed"
                      (click)="openMinuteRequestLine(1)"
                      [icon]="icons.faPen"
                      style="
                        cursor: pointer;
                        font-size: 16px;
                        margin-left: 1rem;
                      "
                    >
                    </fa-icon>
                  </p>
                </div>
              </div>
            </section>
          </section>
        </mat-card-content>
        <ng-template #noClienteSAGR>
          <mat-card-content>
            <p><b>No es cliente SAGR</b></p>
          </mat-card-content>
        </ng-template>
      </mat-card>
    </section>
  </article>
  <article class="container_father">
    <section id="Mercado publico" class="subcontainer">
      <div style="width: 100%; padding-left: 20px">
        <h3>Mercado público</h3>
      </div>
      <mat-card>
        <mat-card-content>
          <section class="grid_container">
            <section class="subcontainer">
              <div class="row">
                <div class="col-md-6">
                  <p>
                    <b>Fecha de inicio en MP: </b>
                    {{
                      minuteRequestClient?.startMP
                        ? (minuteRequestClient.startMP | date : "dd-MM-yyyy")
                        : "-"
                    }}
                  </p>
                  <p>
                    <b>Adjudicación máxima: </b
                    >{{
                      minuteRequestClient?.mp
                        ? (minuteRequestClient?.mp?.maxAdjudication
                          | currency : "CLP" : "symbol")
                        : "-"
                    }}
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <b>Primera adjudicación: </b
                    >{{
                      minuteRequestClient?.mp
                        ? (minuteRequestClient?.mp?.firstAdjudication
                          | date : "dd-MM-yyyy")
                        : "-"
                    }}
                  </p>
                  <p>
                    <b>Primera adjudicación desde ahora: </b
                    >{{
                      minuteRequestClient?.mp
                        ? (minuteRequestClient?.mp?.firstAdjudicationFromNow
                            | number) +
                          " Dias (" +
                          transformDayToMonth(
                            minuteRequestClient?.mp?.firstAdjudicationFromNow
                          ) +
                          " Meses)"
                        : "-"
                    }}
                  </p>
                </div>
              </div>
            </section>
          </section>
        </mat-card-content>
      </mat-card>
    </section>
  </article>
  <article class="container_father">
    <section id="Deudas TGR y CMF" class="subcontainer">
      <div style="width: 100%; padding-left: 20px">
        <h3>TGR y SBIF</h3>
      </div>
      <mat-card>
        <mat-card-content>
          <section class="grid_container">
            <section class="subcontainer">
              <div class="row">
                <div class="col-md-6">
                  <h3>TGR - Deuda</h3>
                  <p>
                    <b>Vigente: </b>
                    {{
                      minuteRequestClient?.tgr?.amountVigente
                        ? (minuteRequestClient?.tgr?.amountVigente
                          | currency : "CLP" : "symbol")
                        : (minuteRequestClient?.tgr?.amountVigente == 0 ? "$0" : "S/Info")
                    }}
                  </p>
                  <p>
                  <b>Convenio: </b>
                    {{
                      minuteRequestClient?.tgr?.amountConvenio
                        ? (minuteRequestClient?.tgr?.amountConvenio
                          | currency : "CLP" : "symbol")
                        : (minuteRequestClient?.tgr?.amountConvenio == 0 ? "$0" : "S/Info")
                    }}
                  </p>
                  <p>
                    <b>Morosa: </b>
                    {{
                      minuteRequestClient?.tgr?.amountMorosa
                        ? (minuteRequestClient?.tgr?.amountMorosa
                          | currency : "CLP" : "symbol")
                        : (minuteRequestClient?.tgr?.amountMorosa == 0 ? "$0" : "S/Info")
                    }}
                  </p>
                  <p>
                    <b>Fecha deuda: </b>
                    {{
                      minuteRequestClient?.tgr?.date
                        ? (minuteRequestClient?.tgr?.date | date : "dd-MM-yyyy")
                        : "S/Info"
                    }}
                  </p>
                  <p>
                    <span (click)="mostrarInforTgr()" style="cursor: pointer"
                      >Abrir Detalle</span>
                  </p>
                </div>
                <div class="col-md-6">
                  <h3>CMF - Deuda ($M)</h3>
                  <p *ngIf="minuteRequestClient?.cmf">
                    <b>Total vigente: </b>
                    {{
                      minuteRequestClient?.cmf?.totalVigente
                        ? (minuteRequestClient?.cmf?.totalVigente
                          | currency : "CLP" : "symbol")
                        : (minuteRequestClient?.cmf?.totalVigente == 0 ? "$0" : "S/Info")
                    }}
                  </p>
                  <p>
                    <b>Total vencida: </b>
                    {{
                      minuteRequestClient?.cmf?.totalVencida
                        ? (minuteRequestClient?.cmf?.totalVencida
                          | currency : "CLP" : "symbol")
                        : (minuteRequestClient?.cmf?.totalVencida == 0 ? "$0" : "S/Info")
                    }}
                  </p>
                  <p>
                    <b>Total morosa: </b>
                    {{
                      minuteRequestClient?.cmf?.totalMorosa
                        ? (minuteRequestClient?.cmf?.totalMorosa
                          | currency : "CLP" : "symbol")
                        : (minuteRequestClient?.cmf?.totalMorosa == 0 ? "$0" : "S/Info")
                    }}
                  </p>
                  <p>
                    <b>Total castigada: </b>
                    {{
                      minuteRequestClient?.cmf?.totalCastigada
                        ? (minuteRequestClient?.cmf?.totalCastigada
                          | currency : "CLP" : "symbol")
                        : (minuteRequestClient?.cmf?.totalCastigada == 0 ? "$0" : "S/Info")
                    }}
                  </p>
                  <p>
                    <b>Fecha consulta: </b>
                    {{
                      minuteRequestClient?.cmf?.requestDate
                        ? (minuteRequestClient?.cmf?.requestDate
                          | date : "dd-MM-yyyy")
                        : "S/info"
                    }}
                  </p>
                  <p>
                    <span (click)="mostrarInforCmf()" style="cursor: pointer"
                      >Abrir Detalle</span
                    >
                  </p>
                </div>
              </div>
            </section>
          </section>
        </mat-card-content>
      </mat-card>
    </section>
  </article>
  <article class="container_father">
    <section id="Dicom" class="subcontainer">
      <div style="width: 100%; padding-left: 20px">
        <h3>DICOM</h3>
      </div>
      <mat-card>
        <mat-card-content>
          <section class="grid_container">
            <section class="subcontainer">
              <div class="row">
                <div class="col">
                  <p>
                    <b>Monto deuda: </b>
                    <span *ngIf="minuteRequestClient?.dicom">
                      {{
                        minuteRequestClient?.dicom?.deudaDicom
                          ? (minuteRequestClient?.dicom?.deudaDicom
                            | currency : "CLP" : "symbol")
                          : "$0"
                      }}
                    </span>
                    <span *ngIf="!minuteRequestClient?.dicom">
                      S/Info
                    </span>
                  </p>
                  <p>
                    <b>Fecha deuda: </b>
                    {{ minuteRequestClient?.dicom?.dateConsultaDicom | date : "dd-MM-yyyy" }}
                  </p>
                  <p>
                    <b>Reporte: </b>
                    <a
                      href="{{ pathUrlDicom }}"
                      target="_blank"
                      style="font-weight: normal; color: #34425a"
                      ><mat-icon matSuffix class="dicomReport"
                        >feed</mat-icon
                    ></a>
                  </p>
                </div>
              </div>
            </section>
          </section>
        </mat-card-content>
      </mat-card>
    </section>
  </article>
  <article class="container_father">
    <section id="SII" class="subcontainer">
      <div style="width: 100%; padding-left: 20px">
        <h3>SII</h3>
      </div>
      <mat-card>
        <mat-card-content>
          <section class="grid_container">
            <section class="subcontainer">
              <div class="row">
                <div class="col">
                  <p>
                    <b>Cliente enrolado: </b
                    >{{ minuteRequestClient?.siiConnected ? "Sí" : "No" }}
                  </p>
                </div>
                <div class="col">
                  <p>
                    <b>Nº de facturas: </b>
                    {{ minuteRequestClient?.sellInvoices | number }}
                  </p>
                </div>
                <div class="col">
                  <p>
                    <b>Es PYME: </b>
                    {{ minuteRequestClient?.isPyme ? "Sí" : "No" }}
                  </p>
                </div>
              </div>
            </section>
          </section>
        </mat-card-content>
      </mat-card>
    </section>
  </article>

  <article class="container_father">
    <section class="subcontainer">
      <div style="width: 100%; padding-left: 20px">
        <h3>Operaciones</h3>
      </div>
      <app-minute-operations-list
        [operations]="minuteRequestRealTime?.operations"
        [forMinute]="true"
        (invoiceOperationToUpdate)="updateInvoiceOperation($event)"
      >
      </app-minute-operations-list>
    </section>
  </article>

  <!-- <article class="container_father" *ngIf="originalFactoringOperation; else noOperations">
      <section class="subcontainer">
        <div style="width: 100%; margin-left: 20px">
          <h3>Operacion</h3>
        </div>
        <mat-card class="container_operations">
          <mat-card-content>
            <article class="subcontainer_minutes">
              <section class="section_info_general">
                <h4>Monto Financiado:</h4>
                <h4>N° Documentos:</h4>
                <h4>Tasa:</h4>
                <h4>Tasa All In:</h4>
                <h4>NFT:</h4>
              </section>
              <section class="section_info">
                <h4>
                  {{
                    originalFactoringOperation?.financedAmount
                      ? (originalFactoringOperation?.financedAmount | currency:'CLP':'symbol')
                      : 0
                  }}
                </h4>
                <h4>Sin info</h4>
                <h4>
                  {{
                    originalFactoringOperation?.rate
                      ? (originalFactoringOperation?.rate | number)
                      : 0
                  }}
                </h4>
                <h4>
                  {{
                    originalFactoringOperation?.allInRate
                      ? (originalFactoringOperation?.allInRate | number)
                      : 0
                  }}
                </h4>
  
                <h4>
                  {{
                    originalFactoringOperation?.invoiceBuyOrder?.numInvoices
                      ? originalFactoringOperation?.invoiceBuyOrder.numInvoices
                      : "Sin Info"
                  }}
                </h4>
              </section>
            </article>
          </mat-card-content>
          <mat-card-content style="padding-top: 16px">
            <article class="subcontainer_minutes">
              <section class="section_info_general">
                <h4>Dif. de Precio:</h4>
                <h4>Gasto Ope. + IVA:</h4>
                <h4>Giro:</h4>
                <h4>Anticipo:</h4>
                <h4>Deudor:</h4>
              </section>
              <section class="section_info">
                <h4>
                  {{
                    originalFactoringOperation?.priceDifference
                      ? (originalFactoringOperation?.priceDifference | currency:'CLP':'symbol')
                      : 0
                  }}
                </h4>
                <h4>
                  {{
                    originalFactoringOperation?.operationalCostWithTax
                      ? (originalFactoringOperation?.operationalCostWithTax
                      | currency:'CLP':'symbol')
                      : 0
                  }}
                </h4>
                <h4>
                  {{
                    originalFactoringOperation?.transferAmount
                      ? (originalFactoringOperation?.transferAmount | currency:'CLP':'symbol')
                      : 0
                  }}
                </h4>
  
                <h4>
                  {{
                    originalFactoringOperation?.downPaymentPercentage
                      ? (originalFactoringOperation?.downPaymentPercentage
                        | number)
                      : 0
                  }}
                </h4>
                <h4>
                  {{
                    originalFactoringOperation?.debtor.name
                      ? originalFactoringOperation?.debtor.name
                      : "Sin Info"
                  }}
                </h4>
              </section>
            </article>
          </mat-card-content>
          <mat-card-content>
            <article class="subcontainer_minutes_grid">
              <section class="section_info_general">
                <h4>Lista Negra:</h4>
                <h4>CMF MM$:</h4>
                <h4>Dicom MM$:</h4>
                <h4>Relacion Comercial Deudor:</h4>
                <h4>Relacion Factoring:</h4>
              </section>
              <section class="section_info">
                <h4>
                  {{ originalFactoringOperation?.debtor.blackList ? "Sí" : "No" }}
                </h4>
                <h4>
                  {{
                    originalFactoringOperation?.debtor.cmfAmount
                      ? (originalFactoringOperation?.debtor.cmfAmount | currency:'CLP':'symbol')
                      : "Sin Info"
                  }}
                </h4>
                <h4>
                  {{
                    originalFactoringOperation?.debtor.dicomAmount
                      ? (originalFactoringOperation?.debtor.dicomAmount | currency:'CLP':'symbol')
                      : "Sin Info"
                  }}
                </h4>
                <h4>
                  {{
                    originalFactoringOperation?.debtor.commercialRelation
                      ? originalFactoringOperation?.debtor.commercialRelation
                      : "Sin Info"
                  }}
                </h4>
                <h4>
                  {{
                    originalFactoringOperation?.debtor.factoringRelation
                      ? originalFactoringOperation?.debtor.factoringRelation
                      : "Sin Info"
                  }}
                </h4>
              </section>
            </article>
          </mat-card-content>
        </mat-card>
      </section>
  
      <section>
        <div style="width: 100%; margin-left: 20px">
          <h3>Orden de Compra</h3>
        </div>
        <mat-card class="container_minutes">
          <mat-card-content>
            <article class="subcontainer_minutes">
              <section class="section_info_general">
                <h4>Monto Orden de Compra:</h4>
                <h4>Fecha de Emision:</h4>
                <h4>Fecha de Emision Factura:</h4>
                <h4>Monto Factura:</h4>
              </section>
              <section class="section_info">
                <h4>
                  {{
                    originalFactoringOperation?.invoiceBuyOrder?.amount
                      ? (originalFactoringOperation?.invoiceBuyOrder.amount
                      | currency:'CLP':'symbol')
                      : "Sin Info"
                  }}
                </h4>
                <h4>
                  {{
                    originalFactoringOperation?.invoiceBuyOrder?.fechaEmision
                      ? (originalFactoringOperation?.invoiceBuyOrder.fechaEmision
                        | date : "dd-MM-yyyy")
                      : "Sin Info"
                  }}
                </h4>
                <h4>
                  {{
                    originalFactoringOperation?.invoiceFechaDocto
                      ? (originalFactoringOperation?.invoiceFechaDocto
                        | date : "dd-MM-yyyy")
                      : "Sin Info"
                  }}
                </h4>
  
                <h4>
                  {{
                    originalFactoringOperation?.invoiceBuyOrder
                      ?.invoiceTotalAmount
                      ? (originalFactoringOperation?.invoiceBuyOrder
                          .invoiceTotalAmount | currency:'CLP':'symbol')
                      : "Sin Info"
                  }}
                </h4>
              </section>
            </article>
          </mat-card-content>
        </mat-card>
      </section>
    </article> -->
  <ng-template #noOperations>
    <mat-card-content style="text-align: center; margin-bottom: 50px">
      <h3>Sin Operaciones a evaluar</h3>
    </mat-card-content>
  </ng-template>

  <!--<article class="container_father page">
    <section class="subcontainer_debtors">
      <div style="width: 100%; padding-left: 20px">
        <h3>Ordenes de Compra</h3>
      </div>
      <mat-card>
        <mat-card-content>
        <article class="container">
            <table>
                <thead>
                    <tr>
                        <th scope="col">Folio</th>
                        <th scope="col">Codigo</th>
                        <th scope="col">Fecha de Emision</th>
                        <th scope="col">Monto</th>
                        <th scope="col">Plazo</th>
                        <th scope="col">SIGFE</th>
                    </tr>
                </thead>
                <tbody *ngIf="minuteRequestRealTime?.operations ; else noDataOrder">
                    <tr *ngFor="let orden of operations">
                        <td>{{ orden.folio }}</td>
                        <td>{{ orden.buyOrder.code }}</td>
                        <td>{{ orden.buyOrder.fechaEmision | date : "dd-MM-yyyy" }}</td>
                        <td>{{ orden.buyOrder.amount | currency:'CLP':'symbol' }}</td>
                        <td>{{ orden.buyOrder.plazo }}</td>
                        <td>{{ orden.buyOrder.sigfe }}</td>
                        <td *ngIf="orden.buyOrder.sigfe"> <fa-icon size="1x" [icon]="iconAproved" style="color: green;"> </fa-icon> </td>
                        <td *ngIf="!orden.buyOrder.sigfe"> <fa-icon size="1x" [icon]="iconReject" style="color: red;"> </fa-icon></td>
                    </tr>
                </tbody>
                <ng-template #noDataOrder>
                    <tr>
                        <td colspan="10">Sin Ordenes de Compra</td>
                    </tr>
                </ng-template>
            </table>
        </article>
        </mat-card-content>
      </mat-card>
    </section>
  </article>-->

  <article class="container_father page">
    <section class="subcontainer_debtors">
      <div style="width: 100%; padding-left: 20px">
        <h3>Deudores</h3>
      </div>
      <mat-card class="cardWithShadow">
        <div class="containerFilter">
          <form
            action=""
            [formGroup]="formFilter"
            cForm
            style="margin-top: 10px"
          >
            <mat-form-field appearance="outline" class="inputRutDebptor">
              <mat-label>Busqueda por Rut o Nombre</mat-label>
              <input
                (keyup.enter)="filterDebtors($event)"
                formControlName="search"
                matInput
              />
            </mat-form-field>
          </form>
          <button
            *ngIf="canApproveAllDebtors() && !minuteRequestRealTime?.isClosed"
            mat-raised-button
            color="primary"
            (click)="approveAllDebtors()"
          >
            Aprobar todos
          </button>
        </div>
        <app-minute-debtor-company-resolutions
          [minuteRequestId]="minuteRequestId"
          [minuteDebtorResolutions]="minuteDebtors"
          [canChangeResolution]="!minuteRequestRealTime?.isClosed"
        >
        </app-minute-debtor-company-resolutions>
      </mat-card>
    </section>
  </article>
  <article class="container_father page">
    <section class="subcontainer_debtors">
      <div style="width: 100%; padding-left: 20px">
        <h3>Top 10 Deudores</h3>
      </div>
      <div>
        <app-minute-top-debtors
          [topDebtors]="minuteRequestKpi.debtorsTop10"
        ></app-minute-top-debtors>
      </div>
    </section>
  </article>

  <article class="container_minutes page2">
    <section class="meses">
      <div style="width: 100%; padding-left: 20px">
        <h3>12 Meses</h3>
      </div>

      <div>
        <app-minutes-debtors
          [debtorsInvoiceHistoric]="minuteRequestKpi.debtorsLast12Months"
        >
        </app-minutes-debtors>
      </div>
    </section>
    <section class="meses page2">
      <div style="width: 100%; padding-left: 20px">
        <h3>24 Meses</h3>
      </div>
      <div>
        <app-minutes-debtors
          [debtorsInvoiceHistoric]="minuteRequestKpi.debtorsLast24Months"
        ></app-minutes-debtors>
      </div>
    </section>
  </article>

  <article class="container_minutes">
    <div>
      <app-minute-factoring-factorization
        [factoringByCesionario]="minuteRequestKpi.factoringByCesionarios"
      />
    </div>
    <!-- <app-table-companies /> -->
  </article>

  <section class="page2" *ngIf="minuteRequestRealTime?.isClosed">
    <div style="width: 100%; padding-left: 20px">
      <h3>Resolucion Comite</h3>
    </div>
    <mat-card class="">
      <mat-card-content class="container_resolution">
        <div class="subcontainer_minutes_grid">
          <section id="htmlData">
            <h4>Resolucion:</h4>
            <h4>Fecha:</h4>
          </section>
          <section id="htmlData">
            <div class="state_minute">
              <div [ngSwitch]="resolutionName">
                <div *ngSwitchCase="'Pendiente'">
                  <h4 style="color: orange">
                    {{ minuteRequestRealTime?.finalResolutionName }}
                  </h4>
                </div>
                <div *ngSwitchCase="'En Borrador'">
                  <h4 style="color: gray">
                    {{ minuteRequestRealTime?.finalResolutionName }}
                  </h4>
                </div>
                <div *ngSwitchCase="'Aprobado'">
                  <h4 style="color: green">
                    {{ minuteRequestRealTime?.finalResolutionName }}
                  </h4>
                </div>

                <div *ngSwitchCase="'Rechazado'">
                  <h4 style="color: red">
                    {{ minuteRequestRealTime?.finalResolutionName }}
                  </h4>
                </div>
              </div>
            </div>

            <h4>
              <span *ngIf="minuteRequestRealTime?.resolutedAt; else noInfo">{{
                minuteRequestRealTime?.resolutedAt | date : "dd-MM-yyyy"
              }}</span>
            </h4>
          </section>
        </div>

        <section class="section_approve">
          <h3>Aprobaciones:</h3>
          <div class="row">
            <div
              *ngFor="let resolution of minuteRequestRealTime?.resolutions"
              class="section_info_approve col-md-6"
            >
              <app-minute-resolution-item
                [minuteResolution]="resolution"
              ></app-minute-resolution-item>
            </div>
          </div>
        </section>
        <section class="section_info">
          <h4 *ngIf="!minuteRequestRealTime?.resolutions">No hay info</h4>
        </section>
      </mat-card-content>
    </mat-card>
    <div class="container_pdf" *ngIf="showButtons">
      <button
        (click)="approveMinute(minuteRequestRealTime.requestMinuteId)"
        mat-stroked-button
        color="primary"
      >
        Aprobar
      </button>

      <button
      mat-raised-button
        color="warn"
        (click)="rejectMinute(minuteRequestRealTime.requestMinuteId)"
      >
        Rechazar
      </button>
    </div>
  </section>

  <div class="container_pdf">
    <button
      *ngIf="minuteRequestRealTime?.finalResolutionName == 'Aprobado'"
      (click)="
        deleteMinute(
          minuteRequestRealTime.requestMinuteId,
          minuteRequestRealTime?.finalResolutionName
        )
      "
      mat-raised-button
      color="warn"
    >
      Anular Minuta
    </button>

    <button
      *ngIf="
        minuteRequestRealTime?.finalResolutionName == 'En Borrador'
      "
      (click)="
        deleteMinute(
          minuteRequestRealTime.requestMinuteId,
          minuteRequestRealTime?.finalResolutionName
        )
      "
      mat-stroked-button
      color="warn"
    >
      Eliminar Minuta
    </button>

    <button
      *ngIf="
        minuteRequestRealTime?.finalResolutionName == 'En Borrador' &&
        !minuteRequestRealTime?.isClosed
      "
      (click)="updateMinutes()"
      mat-raised-button
      color="accent"
    >
      Actualizar Minuta
    </button>
    <button
      *ngIf="
        minuteRequestRealTime?.finalResolutionName == 'En Borrador' &&
        !minuteRequestRealTime?.isClosed
      "
      (click)="closeMinuteConfirmation()"
      mat-raised-button
      color="primary"
    >
      Completar Minuta
    </button>

    <button
      (click)="redirectToMinute(minuteRequestRealTime.requestMinuteId)"
      mat-raised-button
      color="primary"
    >
      Ver PDF
      <mat-icon matSuffix>picture_as_pdf</mat-icon>
    </button>
  </div>

  <div>
    <button
      class="d-flex align-items-center m-y-32"
      type="button"
      mat-stroked-button
      color="primary"
      (click)="goBack()"
    >
      <span class="span_back">
        <i-tabler name="chevron-left" class="m-r-8"></i-tabler>
        <span>Volver</span>
      </span>
    </button>
  </div>
  <!-- <ng-template #spinner>
    <app-spinner-section></app-spinner-section>
  </ng-template> -->

  <ng-template #noInfo>
    <span>No hay info</span>
  </ng-template>
</div>
